import { Menu as BaseMenu } from '@base-ui/react/menu';
import type { ReactNode } from 'react';

export type DropdownMenuItem = {
  label: ReactNode;
  icon?: ReactNode;
  description?: ReactNode;
  onSelect?: () => void;
  disabled?: boolean;
};

export interface DropdownMenuProps {
  triggerLabel: ReactNode;
  items: DropdownMenuItem[];
  triggerClassName?: string;
  triggerAriaLabel?: string;
}

export function DropdownMenu({ triggerLabel, items, triggerClassName, triggerAriaLabel }: DropdownMenuProps) {
  return (
    <BaseMenu.Root>
      <BaseMenu.Trigger aria-label={triggerAriaLabel} className={triggerClassName || "ui-button ui-button--secondary ui-button--md"}>
        <span className="ui-button__label">{triggerLabel}</span>
      </BaseMenu.Trigger>
      <BaseMenu.Portal>
        <BaseMenu.Positioner className="ui-positioner">
          <BaseMenu.Popup className="ui-menu__popup">
            {items.map((item, index) => (
              <BaseMenu.Item
                key={index}
                className="ui-menu__item"
                disabled={item.disabled}
                onClick={item.onSelect}
              >
                {item.icon ? <span className="ui-menu__item-icon" aria-hidden="true">{item.icon}</span> : null}
                <span className="ui-menu__item-copy">
                  <span>{item.label}</span>
                  {item.description ? <small>{item.description}</small> : null}
                </span>
              </BaseMenu.Item>
            ))}
          </BaseMenu.Popup>
        </BaseMenu.Positioner>
      </BaseMenu.Portal>
    </BaseMenu.Root>
  );
}
